import { 
    AppSpan, AppText, Button, CustomContainer, 
    FlexRow, GridContainer 
} from "src/style"
import { AppCenterPopupPlusD2, TitleWithBackIconD2 } from "src/component"

export const StatementConfirmationD2: React.FC<any> = ({type, data, next, back, close}) => {

    return (
        <AppCenterPopupPlusD2
            title='Confirmation' 
            height='50' overflow='hidden'
            contentHeight='50' zIndex='6'
            maxHeight='83'
            close={close}
            back={back}
        >
            <TitleWithBackIconD2 title='Confirmation' backMethod={back}/>
            <CustomContainer>
                <AppText align="center">Please confirm the transaction information below</AppText>
                <CustomContainer
                    minHeight="13.6" borderColor="#EAECF0" padding="2" 
                    radius="0.8" topMargin="2" bgColor="#ffffff"
                >
                    <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap" alignItems="flex-start">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Account No</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.sourceAccount}</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Applicant's Name</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.applicantName || 'Ridwan Kolawole'}</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap" alignItems="flex-start">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Start Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.startDate}</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>End Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.endDate}</AppText>
                        </GridContainer>
                    </FlexRow>
                    { type === 'Embassy' ?
                        <>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap" alignItems="flex-start">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Country</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F">{data?.applicantCountry || 'wttwt'}</AppText>
                                </GridContainer>
                                <GridContainer width="auto" sizeUnit="" alignItems="end">
                                    <AppSpan>Recipient Embassy</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F">{data?.recipientEmbassy}</AppText>
                                </GridContainer>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap" alignItems="flex-start">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Service Fee</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F">N2,000</AppText>
                                </GridContainer>
                            </FlexRow>
                        </>
                        :
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap" alignItems="flex-start">
                            <GridContainer width="auto" sizeUnit="" alignItems="start">
                                <AppSpan>Third Party</AppSpan>
                                <AppText fontWeight="700" color="#0D968F">{data?.thirdParty}</AppText>
                            </GridContainer>
                            <GridContainer width="auto" sizeUnit="" alignItems="end">
                                <AppSpan>Service Fee</AppSpan>
                                <AppText fontWeight="700" color="#0D968F">N2,000</AppText>
                            </GridContainer>
                        </FlexRow>
                    }
                </CustomContainer>
                <Button 
                    width='100' sizeUnit="%" 
                    height='4.4' topMargin="2.5"
                    borderColor='#0D968F' hoverBgColor='#ffffff' 
                    hoverColor='#0D968F' titleSize='1.4'
                    onClick={next}
                >
                    Confirm
                </Button>
            </CustomContainer>
        </AppCenterPopupPlusD2>
    )
}